import { useState, useEffect } from 'react';

const usePagination = (fetchData, initialParams = {}) => {
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 25 });
  const [queryParams, setQuerryParams] = useState(initialParams);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({ rows: [], rowCount: 0 });

  const getQueryString = (params) => {
    return Object.keys(params)
      .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
      .join('&');
  };

  const formatStatus = (data) => {
    data.forEach((row) => {
      row.status = row.status
        .split('-')
        .map((word) => word[0].toUpperCase() + word.slice(1))
        .join(' ');
    });
  };
  const fetchDataFromServer = async () => {
    setLoading(true);
    try {
      const params = { page: paginationModel.page + 1, pageSize: paginationModel.pageSize, ...queryParams };
      const queryString = getQueryString(params);
      const { data } = await fetchData(queryString);
      formatStatus(data.rows || data.docs);
      setData({ rows: data.rows || data.docs, rowCount: data.rowCount || data.totalDocs });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  useEffect(() => {
    fetchDataFromServer();

    // eslint-disable-next-line
  }, [paginationModel, queryParams]);

  const refresh = () => {
    fetchDataFromServer();
  };
  return {
    paginationModel,
    setPaginationModel,
    setQuerryParams,
    loading,
    data,
    refresh,
  };
};

export default usePagination;
